import z from "zod";
import { PermissionItem, ProfessioneEnum } from "../types";
export const provincieItaliane = [
    "Roma",
    "Milano",
    "Catania",
    "Agrigento",
    "Alessandria",
    "Ancona",
    "Aosta",
    "Arezzo",
    "Ascoli Piceno",
    "Asti",
    "Avellino",
    "Bari",
    "Barletta-Andria-Trani",
    "Belluno",
    "Benevento",
    "Bergamo",
    "Biella",
    "Bologna",
    "Bolzano",
    "Brescia",
    "Brindisi",
    "Cagliari",
    "Caltanissetta",
    "Campobasso",
    "Caserta",
    "Catanzaro",
    "Chieti",
    "Como",
    "Cosenza",
    "Cremona",
    "Crotone",
    "Cuneo",
    "Enna",
    "Fermo",
    "Ferrara",
    "Firenze",
    "Foggia",
    "Forlì-Cesena",
    "Frosinone",
    "Genova",
    "Gorizia",
    "Grosseto",
    "Imperia",
    "Isernia",
    "L'Aquila",
    "La Spezia",
    "Latina",
    "Lecce",
    "Lecco",
    "Livorno",
    "Lodi",
    "Lucca",
    "Macerata",
    "Mantova",
    "Massa-Carrara",
    "Matera",
    "Messina",
    "Modena",
    "Monza e della Brianza",
    "Napoli",
    "Novara",
    "Nuoro",
    "Oristano",
    "Padova",
    "Palermo",
    "Parma",
    "Pavia",
    "Perugia",
    "Pesaro e Urbino",
    "Pescara",
    "Piacenza",
    "Pisa",
    "Pistoia",
    "Pordenone",
    "Potenza",
    "Prato",
    "Ragusa",
    "Ravenna",
    "Reggio Calabria",
    "Reggio Emilia",
    "Rieti",
    "Rimini",
    "Roma Capitale",
    "Rovigo",
    "Salerno",
    "Sassari",
    "Savona",
    "Siena",
    "Siracusa",
    "Sondrio",
    "Sud Sardegna",
    "Taranto",
    "Teramo",
    "Terni",
    "Torino",
    "Trapani",
    "Trento",
    "Treviso",
    "Trieste",
    "Udine",
    "Varese",
    "Venezia",
    "Verbano-Cusio-Ossola",
    "Vercelli",
    "Verona",
    "Vibo Valentia",
    "Vicenza",
    "Viterbo",
] as const;
export const nameRegex = /^[A-Za-zÀ-ÖØ-öø-ÿ'’\-\s]+$/;
export const addMonthsToISODate = (
    isoDate?: string,
    months?: number
): string | null => {
    if (!isoDate || !months) return null;

    const [year, month, day] = isoDate.split("-").map(Number);
    const date = new Date(year, month - 1, day);

    const targetMonth = date.getMonth() + months;
    const targetDate = new Date(date);
    targetDate.setMonth(targetMonth);

    // fix fine mese (JS overflow)
    if (targetDate.getDate() !== day) {
        targetDate.setDate(0);
    }

    const y = targetDate.getFullYear();
    const m = String(targetDate.getMonth() + 1).padStart(2, "0");
    const d = String(targetDate.getDate()).padStart(2, "0");

    return `${y}-${m}-${d}`;
};
export const partitaIvaSchema = z
    .string()
    .trim()
    .toUpperCase()
    .refine((val) => {
        // Italiana: 11 cifre numeriche
        const isItaliana = /^[0-9]{11}$/.test(val);

        // Europea: es. DE123456789, IT12345678901, FR123456789AB
        const isEuropea = /^[A-Z]{2}[A-Z0-9]{2,12}$/.test(val);

        // Albanese: es. J12345678L
        const isAlbanese = /^[A-Z]{1}[0-9]{8}[A-Z]{1}$/.test(val);

        return isItaliana || isEuropea || isAlbanese;
    }, {
        message: "Formato partita IVA non valido (Italia, EU o Albania)",
    });
export const passwordSchema = z
    .string()
    .min(8, "La password deve contenere almeno 8 caratteri")
    .max(128, "La password è troppo lunga")
    .regex(/[a-z]/, "Deve contenere almeno una lettera minuscola")
    .regex(/[A-Z]/, "Deve contenere almeno una lettera maiuscola")
    .regex(/[0-9]/, "Deve contenere almeno un numero")
    .regex(/[^A-Za-z0-9]/, "Deve contenere almeno un carattere speciale");
export const permissions: PermissionItem[]  = [
    { label: "amministratore", grant: "admin" },
    { label: "inserisce da landing page", grant: "lp_standalone" },
    { label: "inserisce lead", grant: "create_lead" },
    { label: "qualifica lead", grant: "quality_op" },
    { label: "amministra utenti", grant: "user_admin" },
    { label: "gestisce regole dispatching", grant: "dispatcher_admin" },
    { label: "amministratore fornitore", grant: "fornitore_admin" },
    { label: "amministratore chatbot", grant: "chatbot_admin" },
    { label: "agente", grant: "agent_only" },
    { label: "gestisce landing page agenti", grant: "lp_admin" },
    { label: "crea landing page agenti", grant: "lp_builder" },
];
export const phoneRegex = /^(?:(?:\+39|0039)?\s?)?(3\d{2})\s?\d{6,7}$/;
export const nomeCognomeRegex = /^[A-Za-zÀ-ÖØ-öø-ÿ'’\s-]+$/;
export const required_error = "Campo è obbligatorio";
export const endpoint = "https://europe-west1-ws-digital-3abf0.cloudfunctions.net/api";
// export const endpoint = "https://api-zutje6hexq-ew.a.run.app/api";

const paroleVietate = ["INPS", "NOIPA", "NOI PA", "I.N.P.S.", "N.O.I.P.A."];

// Schema con filtro su parole vietate (case-insensitive)
export const displayNameSchema = z
    .string({required_error})
    .min(3, "Il nome deve contenere almeno 2 caratteri")
    .refine(
        (val) => {
            const valNorm = val.toUpperCase().replace(/\s+/g, "");
            return !paroleVietate.some((bad) =>
                valNorm.includes(bad.replace(/\s+/g, ""))
            );
        },
        { message: "Il nome visualizzato contiene parole non consentite" }
    );
export function normalizePhoneNumber(phone: string): string {
    if (!phone) return "";

    // Rimuove spazi, trattini e parentesi
    let normalized = phone.replace(/[\s\-\(\)]/g, "");

    // Se inizia con +39 lo taglia
    if (normalized.startsWith("+39")) {
        normalized = normalized.slice(3);
    }

    // Se inizia con 0039 lo taglia
    if (normalized.startsWith("0039")) {
        normalized = normalized.slice(4);
    }

    return normalized;
}


export function hasGrant(grants: string[], grant: string): boolean {
    return grants.includes(grant);
}

export function hasAnyGrant(grants: string[], check: string[]): boolean {
    return check.some(g => grants.includes(g));
}

export function truncateWord(word: string, maxLength: number, singlePoint?: boolean): string {
    if (word.length <= maxLength) {
        return word;
    }
    return `${word.slice(0, maxLength)}${singlePoint ? "." : "..."}`;
}

export const standardLeadFormSchema = z.object({
    tipologiaRichiesta: z.enum(["Cessione del Quinto", "Mutuo Immobile"], {
        errorMap: () => ({ message: "Seleziona tipologia" }),
    }),
    distributionChannel: z.enum(["hub", "rete"], {
        errorMap: () => ({ message: "Seleziona destinazione" }),
    }),
    nome: z
        .string({ required_error })
        .min(2, "Il nome è obbligatorio")
        .regex(nomeCognomeRegex, "Il nome può contenere solo lettere e spazi"),
    cognome: z
        .string({ required_error })
        .min(2, "Il cognome è obbligatorio")
        .regex(nomeCognomeRegex, "Il cognome può contenere solo lettere e spazi"),
    importo: z.coerce.number().positive("Importo non valido").optional(),
    provincia: z.string({ required_error }).min(1, "Provincia obbligatoria"),
    email: z.string().email("Email non valida").optional(),
    cellulare: z
        .string({ required_error })
        .min(8, "Cellulare non valido")
        .regex(phoneRegex, "Numero di cellulare italiano non valido"),
    nomeAtc: z.string().optional(),
    pIva: z
        .string()
        .optional()
        .refine((val) => !val || /^\d{11}$/.test(val), {
            message: "La Partita IVA deve contenere esattamente 11 cifre",
        }),
    rating: z.string().optional(),
    professione: z.nativeEnum(ProfessioneEnum, {
        errorMap: () => ({ message: "Seleziona una professione" }),
    }),
    sesso: z
        .enum(["F", "M"], {
            errorMap: () => ({ message: "Seleziona un sesso" }),
        })
        .optional(),
    dataNascita: z
        .string()
        .optional()
        .refine((val) => !val || /^\d{2}\/\d{2}\/\d{4}$/.test(val), {
            message: "Formato data non valido",
        }),
    note: z.string({ required_error }).min(10, "Inserisci una nota valida"),
});
export function randomInt(min: number, max: number): number {
    const minCeil = Math.ceil(min);
    const maxFloor = Math.floor(max);

    return Math.floor(Math.random() * (maxFloor - minCeil + 1)) + minCeil;
}

// ─── Lead Dispatching — costanti e utility ──────────────────────────────────
// Riferimento: docs/FE_LEAD_DISPATCH_HANDOFF.md §7 (header masking) e §11 (mapping errori).

export const LEAD_DISPATCH_ERROR_MESSAGES: Record<string, string> = {
    INVALID_PERCENTAGES:         "La somma delle percentuali deve essere 100",
    INVALID_HOUR_RANGE:          "L'ora di fine deve essere uguale o successiva all'ora di inizio",
    SCHEDULE_OVERLAP:            "Hai due fasce orarie sovrapposte nello stesso giorno",
    MISSING_SIMPLE_RULE:         "Una delle regole semplici referenziate non esiste",
    NESTED_DISPATCHER_FORBIDDEN: "Non puoi usare un dispatcher come target di un altro dispatcher",
    REFERENCED_BY_DISPATCHER:    "Questa regola è ancora usata da uno o più dispatcher",
    RULE_INACTIVE:               "La regola è inattiva",
};

export const SENSITIVE_HEADER_PATTERNS = [
    "authorization",
    "bearer",
    "x-api-key",
    "api-key",
    "token",
    "secret",
    "password",
    "x-auth",
    "signature",
    "cookie",
];

export function isSensitiveHeader(name: string): boolean {
    if (!name) return false;
    const lower = name.toLowerCase();
    return SENSITIVE_HEADER_PATTERNS.some((p) => lower.includes(p));
}
